import { render, staticRenderFns } from "./ShopMenuItemServiceBase.vue?vue&type=template&id=2e84ae0c&"
import script from "./ShopMenuItemServiceBase.vue?vue&type=script&lang=ts&"
export * from "./ShopMenuItemServiceBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports